import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
`

export const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  width: 100%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`

export const FieldRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const FieldLabel = styled.span`
  font-size: 0.75rem;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  flex-shrink: 0;
`

export const FieldValue = styled.span`
  font-size: 0.95rem;
  color: #333;
  font-weight: 500;
  word-break: break-all;
`

export const EmptyState = styled.div`
  color: #aaa;
  font-size: 0.9rem;
  text-align: center;
`
